import type { CensusValidation } from '../../../public/validation/models/census-validation.model';

/** TC-1.1: full validation payload — member + policy + master policyholder + one census line */
const FULL: CensusValidation = {
  memberId: '159708',
  fullName: 'John Doe',
  dateOfBirth: '1980-01-15',
  policyNumber: '101/1241/1500',
  policyholder: 'Acme Trading GmbH',
  masterPolicyholder: 'Globex Holding AG',
  policyStartDate: '2026-01-01',
  policyEndDate: '2026-12-31',
  primaryAssistance: 'TPA Assistance Corp',
  hotline247: '+1 800 555 0101 (Worldwide)',
  censusLines: [
    {
      startDate: '2026-02-01',
      endDate: '2026-12-31',
      planName: 'Gold Health Plan',
      insuranceType: 'Health',
      coverArea: 'Worldwide'
    }
  ]
};

/** TC-1.2: minimal payload — no master policyholder, two census lines */
const MINIMAL: CensusValidation = {
  ...FULL,
  masterPolicyholder: undefined,
  censusLines: [
    ...FULL.censusLines,
    {
      startDate: '2026-03-01',
      endDate: '2026-06-30',
      planName: 'Silver Travel Plan',
      insuranceType: 'Travel',
      coverArea: 'Europe'
    }
  ]
};

export const VALIDATION_SCENARIOS: Record<string, CensusValidation> = {
  TC_1_1: FULL,
  TC_1_2: MINIMAL
};
